import { isCookieConsentAccepted } from "../../utils/cookieConsent";

const storageKey = "_ux_back_teaser";
const cookiesAccepted = isCookieConsentAccepted();

export const getBackTeaserData = (): BackTeaserObject | null => {
    const item = sessionStorage.getItem(storageKey);
    if (item === null) {
        return null;
    }
    try {
        return JSON.parse(item);
    } catch (e) {
        return null;
    }
};

export const setBackTeaserData = (value: BackTeaserObject): void => {
    cookiesAccepted.then(() => {
        sessionStorage.setItem(storageKey, JSON.stringify(value));
    });
};

interface BackTeaserObject {
    title: string;
    href: string;
}
